import { el } from "@dhx/ts-common/dom";
import { getIcon } from "./../../configs/icons";
import { getIconGroup } from "./helpers";
import { Text } from "./Text";

export class AlignBar extends Text {
	constructor(config, ev) {
		super(config, ev);

		this._handlers.iconClick = (id, e) => {
			const val = e.target.getAttribute("dhx_id");
			this.setValue({ ...this._config.value, [id]: val });
		};
	}
	toVDOM() {
		return el(".edit-section.align_bar", { _key: this._uid }, [
			getIconGroup(
				this._handlers.iconClick,
				"horizontal",
				[
					{ id: "left", el: getIcon("align-horizontal-left"), css: "align_icon_wrap" },
					{ id: "center", el: getIcon("align-horizontal-center"), css: "align_icon_wrap" },
					{ id: "right", el: getIcon("align-horizontal-right"), css: "align_icon_wrap" },
				],
				this._config.value.horizontal
			),
			getIconGroup(
				this._handlers.iconClick,
				"vertical",
				[
					{ id: "top", el: getIcon("align-vertical-top"), css: "align_icon_wrap" },
					{ id: "middle", el: getIcon("align-vertical-middle"), css: "align_icon_wrap" },
					{ id: "bottom", el: getIcon("align-vertical-bottom"), css: "align_icon_wrap" },
				],
				this._config.value.vertical
			),
		]);
	}
}
